export const NOTIFICATION_TYPE_CHAT = 'lumahealth/WebNotification/NOTIFICATION_TYPE_CHAT';
export const NOTIFICATION_TYPE_NOTIFICATION_CREATED =
  'lumahealth/WebNotification/NOTIFICATION_TYPE_NOTIFICATION_CREATED';
